module.exports = __webpack_public_path__ + "static/SG_Careers-0201148bf85481410187d7ac4f6b3f8b.png";